import { render, staticRenderFns } from "./star.vue?vue&type=template&id=5401d887&scoped=true"
import script from "./star.vue?vue&type=script&lang=js"
export * from "./star.vue?vue&type=script&lang=js"
import style0 from "./star.vue?vue&type=style&index=0&id=5401d887&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5401d887",
  null
  
)

export default component.exports